import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectProductsState = (store: StoreSchema) => store.products.state
